
import { Name } from "./name";
import { OptionMenu } from "./option-menu";
import { Countries } from "../proto/countries";
import { sprintf } from "sprintf-js";

const GEN_COUNTRIES = () => {
  const names = [];

  Object.keys(Countries).forEach(country => {
    names.push(new Name(
      Countries[country].id,
      sprintf("%s - %s", Countries[country].id, Countries[country].label)));

  });
  return names;
}

class CountryOptionMenu extends OptionMenu {
  constructor(name) {
    super(name, GEN_COUNTRIES());
    this.fake = true;
  }
}

export { CountryOptionMenu };
